function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Kellers = /*#__PURE__*/ function() {
    "use strict";
    function Kellers() {
        _class_call_check(this, Kellers);
    }
    _create_class(Kellers, [
        {
            key: "init",
            value: function init() {
                var _loop = function(i) {
                    var result = kellers[i].num.slice(0, -1);
                    if (result.length === 1) {
                        result = '0' + result;
                    }
                    result = 'k' + result;
                    var elements = document.querySelectorAll('[data-id="'.concat(result, '"]'));
                    elements.forEach(function(element) {
                        element.classList.add(kellers[i].status);
                    });
                };
                var kellers = dataKellers ? dataKellers : [
                    {
                        num: '\u041a027',
                        status: 'status_0',
                        price: 1120000,
                        square: 7,
                        floor: 1
                    }
                ];
                for(var i = 0; i <= kellers.length - 1; i++)_loop(i);
                var sectionItemActive = document.querySelectorAll('[data-floor="1"]');
                sectionItemActive.forEach(function(element) {
                    element.classList.add('active');
                });
                var sectionItem = document.querySelectorAll('[data-kellers-floor]');
                sectionItem.forEach(function($item) {
                    $item.addEventListener('change', function(event) {
                        var elements = document.querySelectorAll("[data-floor]");
                        elements.forEach(function(element) {
                            element.classList.remove('active');
                        });
                        var sectionItemActive = document.querySelectorAll('[data-floor="'.concat($item.value, '"]'));
                        console.log(sectionItemActive);
                        sectionItemActive.forEach(function(element) {
                            element.classList.add('active');
                        });
                    });
                });
                var elements = document.querySelectorAll("[data-id]");
                var popUpAll = document.getElementById('kellers__sheme-pop');
                var back = document.getElementById('kellers-back');
                if (back) {
                    back.addEventListener('click', function(e) {
                        e.stopPropagation();
                        popUpAll.classList.remove('active');
                    });
                }
                popUpAll.addEventListener('mouseover', function() {
                    popUpAll.classList.add('active');
                });
                popUpAll.addEventListener('mouseleave', function() {
                    popUpAll.classList.remove('active');
                });
                elements.forEach(function(element) {
                    element.addEventListener('click', function(e) {
                        e.stopPropagation();
                        var filteredData = kellers.filter(function(item) {
                            var result = item.num.slice(0, -1);
                            if (result.length === 1) {
                                result = '0' + result;
                            }
                            result = 'k' + result;
                            return result === element.getAttribute('data-id');
                        });
                        var place = filteredData[0];
                        document.getElementById('kellers-num').innerText = place.num;
                        document.getElementById('kellers-sq').innerText = place.square;
                        document.getElementById('kellers-fl').innerText = place.floor;
                        localStorage.setItem('keller', place.num);
                        if (place.priceSale) {
                        // document.getElementById('kellers-price').innerText = Number(place.priceSale).toLocaleString('ru-RU') + " ₽"
                        // document.getElementById('kellers-price-sale').innerText = Number(place.price).toLocaleString('ru-RU') + " ₽"
                        } else {
                        // document.getElementById('kellers-price').innerText = Number(place.price).toLocaleString('ru-RU') + " ₽"
                        // document.getElementById('kellers-price-sale').innerText = ""
                        }
                        var rect = element.getBoundingClientRect();
                        var parentRect = element.parentNode.getBoundingClientRect();
                        var topRelativeToParent = rect.top - parentRect.top;
                        var leftRelativeToParent = rect.right - parentRect.left;
                        var popUp = document.getElementById('kellers__sheme-pop');
                        popUp.style.left = leftRelativeToParent + 'px';
                        popUp.style.top = topRelativeToParent + 'px';
                        popUp.classList.add('active');
                    });
                    element.addEventListener('mouseleave', function(e) {
                        e.stopPropagation();
                        var popUp = document.getElementById('kellers__sheme-pop');
                        popUp.classList.remove('active');
                    });
                    element.addEventListener('mouseover', function(e) {
                        e.stopPropagation();
                        var filteredData = kellers.filter(function(item) {
                            var result = item.num.slice(0, -1);
                            if (result.length === 1) {
                                result = '0' + result;
                            }
                            result = 'k' + result;
                            return result === element.getAttribute('data-id');
                        });
                        var place = filteredData[0];
                        document.getElementById('kellers-num').innerText = place.num;
                        localStorage.setItem('keller', place.num);
                        document.getElementById('kellers-sq').innerText = place.square;
                        document.getElementById('kellers-fl').innerText = place.floor;
                        if (place.priceSale) {
                        // document.getElementById('kellers-price').innerText = Number(place.priceSale).toLocaleString('ru-RU') + " ₽"
                        // document.getElementById('kellers-price-sale').innerText = Number(place.price).toLocaleString('ru-RU') + " ₽"
                        } else {
                        // document.getElementById('kellers-price').innerText = Number(place.price).toLocaleString('ru-RU') + " ₽"
                        // document.getElementById('kellers-price-sale').innerText = ""
                        }
                        var rect = element.getBoundingClientRect();
                        var parentRect = element.parentNode.getBoundingClientRect();
                        var topRelativeToParent = rect.top - parentRect.top;
                        var leftRelativeToParent = rect.right - parentRect.left;
                        var popUp = document.getElementById('kellers__sheme-pop');
                        popUp.style.left = leftRelativeToParent + 'px';
                        popUp.style.top = topRelativeToParent + 'px';
                        popUp.classList.add('active');
                    });
                });
            }
        }
    ]);
    return Kellers;
}();
export default Kellers;
